module.exports = __webpack_public_path__ + "static/media/188-peru.6fbfa2e2.svg";